import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Empty, Input, Modal, Tag } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { QUESTION_TYPE_META } from "pages/SurveyManagement/constants";
import styles from "./style.module.scss";

// Picks a company question bank question to link into the survey being built.
const BankPickerModal = ({ open, questions, linkedIds, onPick, onCancel }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  const visible = useMemo(() => {
    const needle = search.trim().toLocaleLowerCase("tr");
    return (questions || []).filter((bq) => {
      if (!needle) return true;
      const haystack = `${bq.question?.text || ""} ${bq.question?.topic || ""}`.toLocaleLowerCase("tr");
      return haystack.includes(needle);
    });
  }, [questions, search]);

  return (
    <Modal
      open={open}
      title={t("surveyManagement.bank.picker_title")}
      footer={null}
      width={680}
      onCancel={onCancel}
      destroyOnClose
    >
      <Input
        allowClear
        prefix={<SearchOutlined />}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={t("surveyManagement.bank.picker_search")}
        className={styles.pickerSearch}
      />
      {visible.length === 0 ? (
        <Empty description={t("surveyManagement.bank.picker_empty")} />
      ) : (
        visible.map((bq) => {
          const already = (linkedIds || []).includes(bq.id);
          const meta = QUESTION_TYPE_META[bq.question?.type] || {};
          return (
            <div key={bq.id} className={styles.surveyRow}>
              <Tag className={styles.kindTag}>{meta.labelKey ? t(meta.labelKey) : bq.question?.type}</Tag>
              <span className={styles.surveyRowText}>
                {bq.question?.text}
                <span className={styles.unusedHint}>
                  {[bq.question?.topic, t("surveyManagement.bank.used_in", { count: (bq.used_in || []).length })]
                    .filter(Boolean)
                    .join(" · ")}
                </span>
              </span>
              <Button size="small" icon={<PlusOutlined />} disabled={already} onClick={() => onPick(bq)}>
                {t(already ? "surveyManagement.bank.picker_added" : "surveyManagement.bank.picker_add")}
              </Button>
            </div>
          );
        })
      )}
    </Modal>
  );
};

export default BankPickerModal;
